import React from "react";
import { useLocation } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import ChatIcon from "@mui/icons-material/Chat";
import SearchIcon from "@mui/icons-material/Search";
import { AddCircle as AddCircleIcon } from "@mui/icons-material";

const NAV_ITEMS = [
  { path: "/home", label: "Inicio", Icon: HomeIcon },
  { path: "/members", label: "Buscar", Icon: SearchIcon },
  { path: "/publish", label: "Publicar", Icon: AddCircleIcon },
  { path: "/chats", label: "Chats", Icon: ChatIcon },
  { path: "/profile", label: "Perfíl", Icon: AccountCircleIcon },
];

const BottomToolbar = () => {
  const location = useLocation();

  return (
    <AppBar
      position="fixed"
      sx={{
        top: "auto",
        bottom: 0,
        borderBottom: "none",
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-around" }}>
        {NAV_ITEMS.map(({ path, label, Icon }) => {
          const active = location.pathname.startsWith(path);
          return (
            <Box
              key={path}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton
                href={path}
                sx={{
                  color: active ? "primary.main" : "text.secondary",
                }}
              >
                <Icon />
              </IconButton>
              <Typography
                variant="caption"
                fontSize={9}
                align="center"
                sx={{ color: active ? "primary.main" : "text.secondary" }}
              >
                {label}
              </Typography>
            </Box>
          );
        })}
      </Toolbar>
    </AppBar>
  );
};

export default BottomToolbar;
